module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


// WEBPACK FOOTER //
// ./node_modules/jszip/node_modules/core-js/library/modules/_fails.js